import React from "react";
import styles from "./PurchaseDetails.module.css";
import lock from "../../assets/images/lock.png";
const PurchaseDetailsFirstSection = (allData) => {
  console.log("PurchaseDetailsFirst", allData);
  const items = allData.data.order_items;
  const order = allData.data.order_details;
  const totalQuantity = allData.data.order_items.reduce(
    (accumulator, item) => accumulator + item.quantity,
    0
  );
  const total =
    allData.data.order_details.total_bill +
    allData.data.order_details.shipping_charge;
  return (
    <div className={styles.firstSection} style={{ position: "relative" }}>
      <div className="mx-auto" style={{ width: "80%" }}>
        <h6 className={styles.firstSectionTitle}>
          <img src={lock} alt="" /> 購入履歴
        </h6>
        <div className="d-flex justify-content-start">
          <h6
            className={`${styles.purchaseDate}`}
            style={{ marginBottom: "30px" }}
          >
            購入日 <span>{order.Created_at}</span>
          </h6>
          <h6 className={styles.purchaseDate}>
            ご注文ID <span>{order.order_code}</span>
          </h6>
        </div>
        <div
          className={`${styles.slideIcon} ${styles.slideIconLeft}`}
          onClick={allData.handleClickLeftSliderIcon}
        >
          {"<"}
        </div>
        <div
          className={`${styles.slideIcon} ${styles.slideIconRight}`}
          onClick={allData.handleClickRightSliderIcon}
        >
          {">"}
        </div>
        {items &&
          Array.isArray(items) &&
          items.length > 0 &&
          items.map((item, i) => (
            <div key={i} className="d-flex mt-4">
              <div className={styles.product}>
                <h6>{item.title}</h6>
              </div>
              <div className={styles.qtylbl}>
                <h6>個数</h6>
              </div>
              <div className={styles.qty}>
                <h6>{item.quantity}</h6>
              </div>
              <div className={styles.pricelbl}>
                <h6>購入金額</h6>
              </div>
              <div className={styles.price}>
                <h6>
                  {new Intl.NumberFormat("ja-JP", {
                    style: "currency",
                    currency: "JPY",
                  }).format(item.Amount)}
                </h6>
              </div>
            </div>
          ))}

        <hr className={styles.hr3} />

        <div className={`d-flex ${styles.secondStep}`}>
          <div className={styles.qtylbl}>
            <h6>個数</h6>
          </div>
          <div className={styles.qty}>
            <h6>{totalQuantity}</h6>
          </div>
          <div className={styles.pricelbl}>
            <h6>商品合計金額</h6>
          </div>
          <div className={styles.price}>
            <h6>
              {new Intl.NumberFormat("ja-JP", {
                style: "currency",
                currency: "JPY",
              }).format(order.total_bill)}
            </h6>
          </div>
        </div>
        <div className={`d-flex mt-3 ${styles.thirdStep}`}>
          <div className={styles.pricelbl}>
            <h6>送料</h6>
          </div>
          <div className={styles.price}>
            <h6>
              {new Intl.NumberFormat("ja-JP", {
                style: "currency",
                currency: "JPY",
              }).format(order.shipping_charge)}
            </h6>
          </div>
        </div>
        <div className={`d-flex mt-3 ${styles.thirdStep}`}>
          <div className={styles.pricelbl}>
            <h6>値引き</h6>
          </div>
          <div className={styles.price}>
            <h6>
              {new Intl.NumberFormat("ja-JP", {
                style: "currency",
                currency: "JPY",
              }).format(order.total_discount ? order.total_discount : 0)}
            </h6>
          </div>
        </div>
        <hr className={styles.hr3} />
        <div className="d-flex mt-4 mb-4">
          <h6 className={styles.paymentType}>決済種別</h6>
          <div className={styles.pro}>
            <h6>{order.payment.payment_by}</h6>
          </div>

          <div className={styles.pricelbl}>
            <h6>購入金額</h6>
          </div>
          <div className={styles.price}>
            <h6>
              {new Intl.NumberFormat("ja-JP", {
                style: "currency",
                currency: "JPY",
              }).format(total)}
            </h6>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PurchaseDetailsFirstSection;
